export default "__VITE_ASSET__2Ko1Rn2J__"